import * as d3 from 'd3'
export default {
  methods: {

    gmx_openPopup(selection, props) {

      let msgGroup = selection
      .append('g')
      .attr('id', `MESSAGE`)
      .attr('transform', `translate(0, 0)`)

      msgGroup
      .append('rect')
      .attr('id', `MSG_BACKGROUND`)
      .attr('rx', 10).attr('ry', 10).attr('width', this.winProps.width).attr('height', this.winProps.height).attr('fill', '#fff').attr('opacity', .8)

      let width = 354, height = 168
      let winH = this.winProps.height == this.Canvas.CanvasHeight ? 150 : 50
      let message = msgGroup
      .append('g')
      .attr('transform', `translate(${this.winProps.width/2-(width/2)}, ${this.winProps.height/2-(height/2) - winH})`)

      message
      .append('rect')
      .attr('x', 2).attr('y', 2)
      .attr('width', width).attr('height', height).attr('rx', 5).attr('ry', 5)
      .attr('fill', '#fff').attr('stroke', '#000').attr('stroke-width', 0)
      .attr('filter', 'url(#msgShadow)').style('opacity', .3)

      message
      .append('image')
      .attr('x', 0).attr('y', 0)
      .attr('xlink:href', this.HOST + `/Database/popup/${props.type}.svg`).attr('height', 172)

      let msgList = message
      .append('g')
      .attr('transform', `translate(100, 72)`)

      props.msg.forEach((d,i)=> {
        msgList
        .append('text')
        .attr('y', i*18).attr('fill', d.color ? d.color : '#333').attr('font-size', d.size ? d.size : 13)
        .text(d.text)
      })

      if(props.type=='Alert') this.msg_Alert(message)
      if(props.type=='Confirm') this.msg_Confirm(message, props)

    },


    msg_Alert(selection) {
      // Cancel
      selection 
      .append('image') 
      .attr('xlink:href', this.HOST + `/Database/btn/Cancel.svg`).attr('x', 260).attr('y', 130).attr('width', 80)
      .call(this.call_msgEvent)
    },


    msg_Confirm(selection, props) {
      // Ok
      selection 
      .append('image').attr('cursor', 'pointer')
      .attr('xlink:href', this.HOST + `/Database/btn/Ok_Blue.svg`)
      .attr('x', 170).attr('y', 130).attr('width', 80)
      .call(this.call_msgEvent, props)

      // Cancel
      selection 
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/btn/Cancel.svg`).attr('x', 260).attr('y', 130).attr('width', 80)
      .call(this.call_msgEvent)
    },


    call_msgEvent(selection, props=null) {
      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() { d3.select(this).transition().duration(75).style('opacity', .5) })
      .on('mouseout', function() { d3.select(this).transition().duration(250).style('opacity', 1) })
      .on('click', () => {
        d3.select(`#MESSAGE`).remove()
        if(props) props.func(props)
      })
    }

  }
}